export default {
    approvalFlow: {
        cooperative: {
            delete: 'Eliminar Cooperativa',
            deactivate: 'Desactivar Cooperativa',
            activate: 'Activar Cooperativa',
            add: 'Agregar Nueva Cooperativa',
            edit: 'Editar Cooperativa',
            cooperativeName: 'Nombre de la Cooperativa',
            membershipPlan: 'Plan de Membresía',
            primaryContact: 'Contacto Principal',
            firstName: 'Nombre',
            lastName: 'Apellido',
            phoneNumber: 'Número de Teléfono',
            email: 'Correo Electrónico',
            location: 'Ubicación',
            country: 'País',
            provinceState: 'Provincia/Estado',
            regionDistrict: 'Región/Distrito',
            villageTownCity: 'Pueblo/Ciudad',
            address: 'Dirección',
            businessInformation: 'Información del Negocio',
            interestedCommodities: 'Productos/Commodities de Interés',
            coffee: 'Café',
            cacao: 'Cacao',
            landRegistered: '¿Cuánta tierra será registrada? (en hectáreas)',
            userType: 'Tipo de Usuario',
            exporter: 'Exportador',
            cooperative: 'Cooperativa',
            bothOfThem: 'Ambos',
            uploadLogo: 'Subir copia del Logo',
            uploadLogoButton: 'SUBIR LOGO',
            enterHere: 'Ingrese aquí',
            select: 'Seleccionar',
            cooperativeNameRequired: 'El nombre de la cooperativa es requerido',
            firstNameRequired: 'El nombre es requerido',
            emailRequired: 'El correo electrónico es requerido',
            invalidEmail: 'Correo electrónico inválido',
            required: 'Requerido',
            pleaseUploadValidImage: 'Por favor suba un archivo de imagen válido',
            errorPreparingData: 'Error preparando datos',
            cancel: 'Cancelar',
            save: 'Guardar',
            update: 'Actualizar',
            dueDiligenceReports: 'Informes de Debida Diligencia',

            // List page translations
            listOfCooperatives: 'Lista de Cooperativas',
            addCooperatives: 'Agregar Cooperativas',
            loadingData: 'Cargando datos...',
            search: 'Buscar',
            type: 'Tipo',
            cooperativeTypeInformation: 'Información del Tipo de Cooperativa',
            all: 'Todos',
            of: 'de',
            active: 'Activo',
            unregistered: 'No Registrado',
            deactivated: 'Desactivado',
            view: 'Ver',
            confirmDelete: 'Confirmar Eliminación',
            areYouSureDeleteCooperative: '¿Está seguro de que desea eliminar esta cooperativa?',
            updatedSuccessfully: 'Actualizado exitosamente',
            createdSuccessfully: 'Creado exitosamente',
            errorFetchingCooperativeDetails: 'Error al obtener detalles de la cooperativa',
            errorSavingCooperative: 'Error al guardar cooperativa',
            errorFetchingCooperativesData: 'Error al obtener datos de cooperativas',
            cooperativeDeactivatedSuccessfully: 'Cooperativa desactivada exitosamente',
            errorDeactivatingCooperative: 'Error al desactivar cooperativa',
            cooperativeDeletedSuccessfully: 'Cooperativa eliminada exitosamente',
            errorDeletingCooperative: 'Error al eliminar cooperativa',
            noOfFarms: 'No. de Granjas',
            cropsProducts: 'Cultivos/Productos',
            status: 'Estado',
            actions: 'Acciones',
            cooperativeAndExporter: 'Cooperativa + Exportador',
            cooperativeActivatedSuccessfully: 'Cooperativa activada exitosamente',
            back: 'Kembali',
            commoditiesProducts: 'Detail Cooperativa',
            cooperativeEmail: 'Email Cooperativa',
            cooperativePhoneNumber: 'Nomor Telepon Cooperativa',
            logo: 'Logo',
            advanced: 'Avanzado',

            // Tooltips
             statusTT: 'Estado actual de la cooperativa en el sistema (e.g., Activo, Desactivado, No registrado).',
             logoTT: 'Imagen oficial o símbolo del logo de la organización para la marca en reportes/páginas QR.',
             cooperativeNameTT: 'Nombre legal registrado de la cooperativa, utilizado en todos los registros de cumplimiento y reportes.',
             primaryContactTT: 'Nombre del contacto, correo electrónico, teléfono.',
             locationTT: 'Filtrar por texto de ubicación (país/provincia/ciudad).',
             membershipPlanTT: 'El plan o acuerdo que establece los términos y condiciones de membresía en la cooperativa.',
             countryTT: 'El país donde la cooperativa está legalmente registrada y opera. Esto ayuda a alinear los reportes con las regulaciones nacionales.',
             provinceStateTT: 'La provincia o estado donde la cooperativa está legalmente registrada y opera. Esto ayuda a alinear los reportes con las regulaciones regionales.',
             regionDistrictTT: 'La región o distrito donde la cooperativa está basada. Esto ayuda a garantizar una identificación precisa a nivel comunitario.',
             villageTownCityTT: 'El nombre del asentamiento local (pueblo, ciudad) donde la cooperativa está basada. Esto garantiza una identificación precisa a nivel comunitario.',
             addressTT: 'La dirección física o postal de la cooperativa. Esto debería incluir detalles de la calle, si están disponibles, para una referencia precisa en los reportes.',
             interestedCommoditiesTT: 'Muestra el código y nombre del producto asociado con el reporte. Este campo ayuda a los usuarios a entender qué producto está relacionado con el reporte.',
             userTypeTT: 'Filtrar resultados por rol/tipo de cooperativa.',
             organization: 'Organización',
             selectOrganization: 'Seleccionar organización',
             dateFrom: 'Fecha desde',
             dateTo: 'Fecha hasta',
            registrationDate: 'Fecha de registro',
            downloadFarms: 'Descargar Fincas',
            noFarmsFound: 'No se encontraron fincas para esta cooperativa.',
        },
    },
};
